export default __webpack_public_path__ + "static/media/s4.9a91e940.png";